export default "__VITE_ASSET__DWVxI5SE__"